import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const CreditCard = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="credit card icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M0.126017 5.98193C0.57006 4.25671 2.13616 2.98193 4 2.98193H20C21.8638 2.98193 23.4299 4.25671 23.874 5.98193H0.126017Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 8.98193H24V16.9819C24 19.1911 22.2091 20.9819 20 20.9819H4C1.79086 20.9819 0 19.1911 0 16.9819V8.98193ZM5.5 13.9819C4.67157 13.9819 4 14.6535 4 15.4819C4 16.3104 4.67157 16.9819 5.5 16.9819H10.5C11.3284 16.9819 12 16.3104 12 15.4819C12 14.6535 11.3284 13.9819 10.5 13.9819H5.5Z"
    />
  </svg>
)
